import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { replace, push } from 'react-router-redux';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import {
  Button,
  Container,
  Dimmer,
  Divider,
  Dropdown,
  Form,
  Grid,
  Header,
  Icon,
  Label,
  Loader,
  Menu,
  Segment,
} from 'semantic-ui-react';
import config from '../../../config';
import fileSize from '../../utils/fileSize';
import { fetchM } from '../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../actions/flash';

import ContentPlaceholder from '../../components/ContentPlaceholder';
import EditableBox from '../../components/EditableBox';
import GalleryList from '../../components/GalleryList';
import LoadImage from '../../components/LoadImage';
import NavBar from '../../components/NavBar';
import SpecificationTable from '../../components/SpecificationTable';
import Timestamp from '../../components/Timestamp';
import UnitLayoutItem from '../../components/UnitLayoutItem';
import MarkdownText from '../../components/MarkdownText';
import Phone from '../../components/Phone';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

import ViewLarge from '../modals/ViewLarge';
import UnitsList from '../modals/UnitsList';
import ModalConfirm from '../modals/ModalConfirm';
import { routes } from './navigations';
import { sanitizeUrl } from '../../utils/url';
import { showsLayoutReserveButton } from '../../utils/vietnam';
import { reservationBlocked } from '../../utils/preSalesLaunch';

moment.locale('en-gb');

class Overview extends Component {
  static propTypes = {
    id: PropTypes.string,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isSiteplan: PropTypes.bool,
    }),
    data: PropTypes.shape({
      projectPictures: PropTypes.array,
      gps: PropTypes.string,
      maOwnerCompanyBranchID: PropTypes.number,
    }),
    onCheck: PropTypes.func,
    token: PropTypes.string,
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const data = props.data || {};
    const editData = JSON.parse(JSON.stringify(data));
    const loading = props.loading;
    const menuIsTab = window.innerWidth <= 590;
    const unitLayoutResize = window.innerWidth < 768;
    const galleryIsTab = window.innerWidth > 425;
    const locationResize = window.innerWidth <= 375;
    return {
      data,
      editData,
      loading,
      menuIsTab,
      unitLayoutResize,
      galleryIsTab,
      locationResize,
    };
  }
  constructor(props) {
    super(props);
    const state = Overview.getPropsToState(props);
    this.state = {
      ...state,
      pictures: [],
      slideshow: false,
      showLarge: false,
      selectedPicture: null,
      showBookUnit: false,
      unitLayout: null,
      hasChanges: false,
      showModalConfirm: false,
      viewLargeType: 'picture',
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = Overview.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  getCoverPicture = (pictures) => {
    if (pictures && pictures.length > 0 && pictures.some(pp => pp.isCover === true)) {
      return pictures.find(pp => pp.isCover === true).picture;
    }
    return null;
  }
  getMapPicture = (pictures) => {
    if (pictures && pictures.length > 0 && pictures.some(pp => pp.type === 'map')) {
      return pictures.find(pp => pp.type === 'map').picture;
    }
    return null;
  }
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  handleOnCheck = (hasChanges = false) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges);
    }
  }
  handleCheckChanges() {
    if (!this.state.hasChanges) {
      this.setState({ hasChanges: true }, () => {
        this.handleOnCheck(true);
      });
    }
  }
  handleResetCheck() {
    if (this.state.hasChanges) {
      this.setState({ hasChanges: false }, () => {
        this.handleOnCheck(false);
      });
    }
  }
  hasAccess(check = false) {
    const user = this.props.auth;
    if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
      return true;
    }
    if (this.props.auth.isBranchLeaderSupervisorII && this.props.data &&
      (this.props.data.maOwnerCompanyBranchID === user.companyBranch.id)
    ) {
      return true;
    }
    return check;
  }
  handleResize = () => {
    const state = {};
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    const unitLayoutResize = window.innerWidth < 768;
    if (unitLayoutResize !== this.state.unitLayoutResize) {
      state.unitLayoutResize = unitLayoutResize;
    }
    const galleryIsTab = window.innerWidth > 425;
    if (galleryIsTab !== this.state.galleryIsTab) {
      state.galleryIsTab = galleryIsTab;
    }
    const locationResize = window.innerWidth <= 375;
    if (locationResize !== this.state.locationResize) {
      state.locationResize = locationResize;
    }
    this.setState({ ...state });
  }
  handleCloseLarge = (e) => {
    e.preventDefault();
    this.setState({
      showLarge: false,
      selectedPicture: null,
      slideshow: false,
    });
  }
  handleViewLarge = (e, data) => {
    e.preventDefault();
    this.setState({
      selectedPicture: data,
      showLarge: true,
      slideshow: false,
      viewLargeType: 'picture',
    });
  }
  handleViewLargeSlide = (e, data, viewLargeType = 'picture') => {
    e.preventDefault();
    this.setState({
      selectedPicture: data,
      showLarge: true,
      slideshow: true,
      viewLargeType,
    });
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    if (value.includes(config.get('bookApiURL')) || value.includes(config.get('salesChartURL'))) {
      e.preventDefault();
      const winObj = window.open(value, '_blank');
      winObj.opener = null;
    } else {
      store.dispatch(replace(value));
    }
  }
  handleCloseBookUnit = (e) => {
    e.preventDefault();
    this.setState({
      showBookUnit: false,
      unitLayout: null,
    });
  }
  handleOpenBookUnit = (e, unitLayout) => {
    e.preventDefault();
    this.setState({
      unitLayout,
      showBookUnit: true,
    });
  }
  handleUnitClick = (e, { unit }) => {
    const { store } = this.context;
    store.dispatch(push(`/projects/${this.props.id}/units/${unit.id}/`));
  }
  handleSpecificationsChange = (data) => {
    const { editData } = this.state;
    editData.specifications = data;
    this.setState({ editData }, () => {
      this.handleCheckChanges();
    });
  }
  handleInputChange = (event, data) => {
    const { editData } = this.state;
    editData[data.name] = data.value;
    this.setState({ editData }, () => {
      this.handleCheckChanges();
    });
  }
  handleUpdateProject = () => {
    const { data, editData } = this.state;
    if (editData.specifications) {
      editData.specifications = editData.specifications.filter(d =>
        d.name.length > 0 && d.value.length > 0).map((d, idx) => ({
          ...d,
          position: idx + 1,
        }));
    }
    if (JSON.stringify(editData) !== JSON.stringify(data)) {
      this.updateProject(editData);
    }
    this.handleResetProject();
  }
  handleResetProject = () => {
    const editData = JSON.parse(JSON.stringify(this.state.data));
    this.setState({ editData }, () => {
      this.handleResetCheck();
    });
  }
  async updateProject(project) {
    const { store } = this.context;
    const { t } = this.props;
    await this.setComponentState({ loading: true });
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(project),
      }));
    } catch (err) {
      Bugsnag.notifyException(err);
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
    }
    const data = await res.json();
    await this.setComponentState({ loading: false }, () => {
      this.handleResetCheck();
    });
    store.dispatch(push(`/projects/${this.props.id}/`));
    store.dispatch(flashSuccessMessage({
      header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
      message: t('{{name}} successfully updated', { name: data.name, ns: TRANSLATION_FILES.translation }),
    }));
  }
  handleGetPicture = (pictures) => {
    this.setState({ pictures });
  }
  handleSlidePicture = (e, direction = 'right') => {
    const { pictures, selectedPicture } = this.state;
    const index = pictures.indexOf(selectedPicture);
    const nextIndex = direction === 'left' ? index - 1 : index + 1;
    this.setState({
      selectedPicture: pictures[nextIndex],
    });
  }
  checkDisabled(direction = 'right') {
    const { pictures, selectedPicture } = this.state;
    if (selectedPicture) {
      const index = pictures.indexOf(selectedPicture);
      if (direction === 'left') {
        return index - 1 >= 0;
      }
      return index + 1 < pictures.length;
    }
    return false;
  }
  handleShowModalConfirm = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showModalConfirm: true,
    });
  }
  handleCloseModalConfirm = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showModalConfirm: false,
    });
  }
  handleDuplicatesProject = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({ showModalConfirm: false }, () => {
      this.duplicatesProject();
    });
  }
  async duplicatesProject() {
    const { store } = this.context;
    const { t } = this.props;
    await this.setComponentState({ loading: true });
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/duplicate/`, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      store.dispatch(flashErrorMessage(err));
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setComponentState({ loading: false });
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
      await this.setComponentState({ loading: false });
    } else {
      const data = await res.json();
      window.location.href = `/projects/${data.id}/`;
    }
  }
  render() {
    const { pathname } = this.props.location;
    const { store } = this.context;
    const { data, editData } = this.state;
    const { t } = this.props;
    // CPI-1292; Pre-Sales Launch: hidden for a role HQ has blocked from reserving on this project
    const canReserve = showsLayoutReserveButton(this.props.auth) &&
      !reservationBlocked(this.props.auth, data);
    const links = routes(this.props.id, data, this.hasAccess(), this.props.auth.isSiteplan, this.props.auth).map(l => ({
      ...l,
      text: t(l.text),
    }));
    return (
      <Container>
        <ModalConfirm
          open={this.state.showModalConfirm}
          onClose={this.handleCloseModalConfirm}
          onConfirm={this.handleDuplicatesProject}
          headerNode={`${t('Copy project')}?`}
          content={`${t('Are you sure you want to duplicate this project? This action will not be reversible')}.`}
        />
        <NavBar
          links={
            this.state.menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={link.text}
                content={link.text}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
          rightNav={this.hasAccess() ?
            <Menu.Item fitted>
              <div>
                <Button
                  icon
                  title={t('Copy project')}
                  disabled={this.state.loading}
                  onClick={e => this.handleShowModalConfirm(e)}
                >
                  <Icon name="copy" />
                </Button>
                <Button
                  as={Link}
                  primary
                  content={t('Edit', { ns: TRANSLATION_FILES.translation })}
                  disabled={this.state.loading}
                  to={`/projects/${this.props.id}/edit/`}
                />
              </div>
            </Menu.Item> : null
          }
        />
        <Grid verticalAlign="top" columns="equal" stackable>
          <ViewLarge
            open={this.state.showLarge}
            onClose={this.handleCloseLarge}
            picture={this.state.selectedPicture}
            onSlide={this.handleSlidePicture}
            disabledLeft={!this.checkDisabled('left')}
            disabledRight={!this.checkDisabled('right')}
            slideshow={this.state.slideshow}
            type={this.state.viewLargeType}
          />
          <UnitsList
            open={this.state.showBookUnit}
            onClose={this.handleCloseBookUnit}
            onConfirm={this.handleUnitClick}
            projectID={this.props.id}
            projectData={data}
            unitLayout={this.state.unitLayout}
          />
          <Grid.Row verticalAlign="middle" columns={1}>
            <Grid.Column>
              <ContentPlaceholder
                header
                subheader
                loading={this.state.loading}
              >
                <Header
                  size="large"
                  style={{ marginBottom: '0.3em' }}
                  content={data.name || t('Project')}
                  subheader={data.address6 ? `${data.address6}, ${data.address7}` : null}
                />
              </ContentPlaceholder>
              <Label.Group size="small">
                {data.isCommercial ? <Label content={t('Commercial')} /> : null}
                {data.isIndustrial ? <Label content={t('Industrial')} /> : null}
                {data.isResidential ? <Label content={t('Residential')} /> : null}
              </Label.Group>
            </Grid.Column>
            <Grid.Column>
              <Grid>
                <Grid.Row verticalAlign="top">
                  <Grid.Column mobile={16} tablet={16} computer={8} style={{ marginBottom: '1em' }}>
                    {
                      this.hasAccess(this.getCoverPicture(data.projectPictures)) ? (
                        <LoadImage
                          fluid
                          cover="long"
                          centered
                          loading={this.state.loading}
                          onClick={e => this.handleViewLarge(e,
                            this.getCoverPicture(data.projectPictures))}
                          labelNode={this.hasAccess() ?
                            <Label
                              as={Link}
                              attached="top right"
                              size="small"
                              content={t('Edit', { ns: TRANSLATION_FILES.translation })}
                              icon="pencil"
                              to={`/projects/${this.props.id}/pictures/`}
                              disabled={this.state.loading}
                            /> : null
                          }
                          notFoundNode={
                            <div>
                              <p>{t('No cover picture found')}.</p>
                              <Button
                                as={Link}
                                primary compact
                                disabled={this.state.loading}
                                to={`/projects/${this.props.id}/pictures/`}
                                content={t('Click here to add')}
                              />
                            </div>
                          }
                          picture={this.getCoverPicture(data.projectPictures)}
                          pictureSize={70}
                        />
                      ) : null
                    }
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    {
                      this.hasAccess(data.specifications && data.specifications.length > 0) ?
                        <Grid.Row>
                          <Grid.Column>
                            <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
                              <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                            </Dimmer>
                            <SpecificationTable
                              tableStyle={{ marginTop: '0' }}
                              type="projects"
                              data={editData.specifications}
                              editable={this.hasAccess()}
                              headerNode={t('Project Information')}
                              loading={this.state.loading}
                              onChange={this.handleSpecificationsChange}
                              onClick={this.handleUpdateProject}
                              onCancel={this.handleResetProject}
                              notFoundNode={<p>{t('No information set')}.</p>}
                              onAdd={() => store.dispatch(push(`/projects/${this.props.id}/edit/#specifications`))}
                            />
                          </Grid.Column>
                        </Grid.Row>
                      : null
                    }
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
          {
            this.hasAccess(data.overviewTitle || data.overviewSubTitle || data.overviewExtLinkUrl || data.overview) ?
              <Divider horizontal>{t('Project Description')}</Divider> : null
          }
          {
            this.hasAccess(data.overviewTitle || data.overviewSubTitle || data.overviewExtLinkUrl || data.overview) ?
              <Grid.Row>
                <Grid.Column>
                  <Container textAlign="justified">
                    <EditableBox
                      hideBorder
                      editable={this.hasAccess()}
                      loading={this.state.loading}
                      onClick={this.handleUpdateProject}
                      onCancel={this.handleResetProject}
                      content={({ isEditing, onConfirm }) => (
                        isEditing ? (
                          <Form onSubmit={onConfirm}>
                            <Form.Input
                              fluid
                              label={t('Title')}
                              name="overviewTitle"
                              onChange={this.handleInputChange}
                              value={editData.overviewTitle}
                            />
                            <Form.Input
                              fluid
                              label={t('Subtitle')}
                              name="overviewSubTitle"
                              onChange={this.handleInputChange}
                              value={editData.overviewSubTitle}
                            />
                            <Segment padded style={{ border: '1px solid rgba(34,36,38,0.15)', borderRadius: 8, marginBottom: '1rem' }}>
                              <Form.Field>
                                <span>
                                  <Icon name="external alternate" /> {t('externalLink')}
                                </span>
                                <Form.Group widths="equal">
                                  <Form.Input
                                    width={6}
                                    label={t('buttonName', { ns: TRANSLATION_FILES.screens })}
                                    name="overviewExtLinkTitle"
                                    value={editData.overviewExtLinkTitle || ''}
                                    onChange={this.handleInputChange}
                                  />
                                  <Form.Input
                                    width={10}
                                    label={t('linkUrl', { ns: TRANSLATION_FILES.screens })}
                                    name="overviewExtLinkUrl"
                                    value={editData.overviewExtLinkUrl || ''}
                                    onChange={this.handleInputChange}
                                  />
                                </Form.Group>
                              </Form.Field>
                            </Segment>
                            <Form.TextArea
                              label={t('Description')}
                              name="overview"
                              value={editData.overview}
                              onChange={this.handleInputChange}
                            />
                          </Form>
                        ) : (
                          <ContentPlaceholder
                            header
                            subheader
                            paragraphs
                            loading={this.state.loading}
                            expandable
                          >
                            {
                              data.overviewTitle || data.overviewSubTitle ?
                                <Header
                                  as="h2"
                                  content={data.overviewTitle || data.overviewSubTitle}
                                  subheader={data.overviewTitle ? data.overviewSubTitle : null}
                                /> : null
                            }
                            {
                              data.overviewExtLinkUrl ? (
                                <Button
                                  href={sanitizeUrl(data.overviewExtLinkUrl)}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  primary
                                  compact
                                  style={{ marginBottom: '0.5rem' }}
                                >
                                  <Icon name="external alternate" />
                                  {data.overviewExtLinkTitle}
                                </Button>
                              ) : null
                            }
                            {
                              data.overview ?
                                <MarkdownText content={data.overview} /> :
                                <Segment textAlign="center">
                                  <p>{t('Description not set')}.</p>
                                  <Button
                                    as={Link}
                                    primary compact
                                    disabled={this.state.loading}
                                    to={`/projects/${this.props.id}/edit/#overview`}
                                    content={t('Click here to add')}
                                  />
                                </Segment>
                            }
                          </ContentPlaceholder>
                        )
                      )}
                    />
                  </Container>
                </Grid.Column>
              </Grid.Row>
            : null
          }
          {
            this.hasAccess(data.unitLayouts && data.unitLayouts.length > 0) ?
              <Divider horizontal>{t('Layouts')}</Divider> : null
          }
          {
            this.hasAccess(data.unitLayouts && data.unitLayouts.length > 0) ?
              <Grid.Row>
                <Grid.Column>
                  <Dimmer style={{ zIndex: 20 }} active={this.state.loading} inverted>
                    <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                  </Dimmer>
                  <Segment.Group>
                    {
                      data.unitLayouts && data.unitLayouts.length > 0 ?
                      data.unitLayouts.map((unitLayout, key) => (
                        <UnitLayoutItem
                          key={key}
                          isMobile={this.state.unitLayoutResize}
                          loading={this.state.loading}
                          buttonNode={({ loading }) => (
                            <Button.Group
                              fluid
                              floated="right"
                              widths={2 + (unitLayout.virtualTourURL !== '' ? 1 : 0) + (canReserve ? 1 : 0)}
                              basic
                              primary
                            >
                              {
                                unitLayout.virtualTourURL !== '' ? (
                                  <Button
                                    as="a"
                                    content={t('Virtual Tour')}
                                    disabled={loading}
                                    href={unitLayout.virtualTourURL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="button-reduce-spacing"
                                  />
                                ) : null
                              }
                              <Button
                                as={Link}
                                content={t('View', { ns: TRANSLATION_FILES.translation })}
                                disabled={loading}
                                to={`/projects/${this.props.id}/layouts/${unitLayout.id}/`}
                                className="button-reduce-spacing"
                              />
                              {
                                canReserve ? (
                                  <Button
                                    content={t('Reserve')}
                                    disabled={loading}
                                    onClick={e => this.handleOpenBookUnit(e, unitLayout)}
                                    className="button-reduce-spacing"
                                  />
                                ) : null
                              }
                              <Button
                                content={t('Compare')}
                                disabled={loading}
                                as={Link}
                                to={`/projects/${this.props.id}/layouts/compare/?layoutID=${unitLayout.id}`}
                                className="button-reduce-spacing"
                              />
                            </Button.Group>
                          )}
                          project={data}
                          {...unitLayout}
                        />
                      ))
                      : (
                        <Segment textAlign="center">
                          <p>{t('No unit layouts found')}.</p>
                          <Button
                            as={Link}
                            primary compact
                            disabled={this.state.loading}
                            to={`/projects/${this.props.id}/layouts/`}
                            content={t('Click here to add')}
                          />
                        </Segment>
                      )
                    }
                  </Segment.Group>
                </Grid.Column>
              </Grid.Row>
            : null
          }
          {
            this.hasAccess(data.projectPictures && data.projectPictures.length > 0 &&
            data.projectPictures.some(pp => pp.picture.type !== 'map')) ?
              <Divider horizontal>{t('Gallery')}</Divider> : null
          }
          {
            this.hasAccess((data.projectPictures && data.projectPictures.length > 0 &&
            data.projectPictures.some(pp => pp.picture.type !== 'map')) ||
            (data.medias && data.medias.length > 0)) ?
              <Grid.Row>
                <Grid.Column>
                  <GalleryList
                    editable={this.hasAccess()}
                    pictures={[].concat(data.projectPictures || [], data.medias || [])}
                    projectID={this.props.id}
                    loading={this.state.loading}
                    excludeType={['map']}
                    tabular={this.state.galleryIsTab}
                    onViewLarge={this.handleViewLargeSlide}
                    onChange={this.handleGetPicture}
                    addPath={`/projects/${this.props.id}/pictures/`}
                    addVideoPath={`/projects/${this.props.id}/videos/`}
                  />
                </Grid.Column>
              </Grid.Row>
            : null
          }
          {
            this.hasAccess(data.documents && data.documents.length > 0) ?
              <Divider horizontal>{t('Documents')}</Divider> : null
          }
          {
            this.hasAccess(data.documents && data.documents.length > 0) ?
              <Grid.Row>
                <Grid.Column>
                  <Segment.Group>
                    {
                      data.documents && data.documents.length > 0 ?
                      data.documents.map((file, idx) => (
                        <Segment key={idx}>
                          <Grid
                            columns="equal"
                            verticalAlign="middle"
                            as="a"
                            href={`${config.get('bookApiURL')}/documents/${file.id}/view/${encodeURIComponent(file.name)}.pdf`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <Grid.Column>
                              <Icon name="file pdf outline" />
                              {file.name}
                              <span className="mobile-hide"> ({fileSize(file.size)})</span>
                              <small className="large-hide small-hide tablet-hide"><br />{fileSize(file.size)}</small>
                            </Grid.Column>
                            <Grid.Column textAlign="right">
                              <small><Timestamp format="DD/MM/YY hh:mm a" timestamp={file.createdAt} /></small>
                            </Grid.Column>
                          </Grid>
                        </Segment>
                      )) : (
                        <Segment textAlign="center">
                          <p>{t('No documents found')}.</p>
                          <Button
                            as={Link}
                            primary compact
                            disabled={this.state.loading}
                            to={`/projects/${this.props.id}/documents/`}
                            content={t('Click here to add')}
                          />
                        </Segment>
                      )
                    }
                  </Segment.Group>
                </Grid.Column>
              </Grid.Row>
            : null
          }
          <Divider horizontal>{t('Location')}</Divider>
          <Grid.Row>
            {
              (this.getMapPicture(data.projectPictures) || this.hasAccess())
              && <Grid.Column width={8} stretched>
                <LoadImage
                  fluid
                  cover="long"
                  centered
                  onClick={e => this.handleViewLarge(e,
                    this.getMapPicture(data.projectPictures))}
                  labelNode={this.hasAccess() &&
                    <Label
                      as={Link}
                      attached="top right"
                      size="small"
                      content={t('Edit', { ns: TRANSLATION_FILES.translation })}
                      icon="pencil"
                      to={`/projects/${this.props.id}/pictures/`}
                      disabled={this.state.loading}
                    />
                  }
                  notFoundNode={
                    <div>
                      <p>{t('No map found')}.</p>
                      {this.hasAccess() && <Button
                        as={Link}
                        primary compact
                        disabled={this.state.loading}
                        to={`/projects/${this.props.id}/pictures/?tab=map`}
                        content={t('Click here to add')}
                      />}
                    </div>
                  }
                  picture={this.getMapPicture(data.projectPictures)}
                  pictureSize={70}
                />
              </Grid.Column>
            }
            <Grid.Column stretched>
              <Grid columns="equal" stackable={this.state.locationResize}>
                <Grid.Column>
                  <Header icon="map marker alternate" content={t('Address')} />
                  <ContentPlaceholder
                    paragraphs
                    loading={this.state.loading}
                  >
                    <p
                      dangerouslySetInnerHTML={{ __html: data.fullAddressHTML }}
                    />
                  </ContentPlaceholder>
                </Grid.Column>
                <Grid.Column>
                  <Header icon="phone" content={t('Phone')} />
                  <ContentPlaceholder
                    paragraphs={1}
                    loading={this.state.loading}
                  >
                    {
                      data.phone ?
                        <Phone
                          mobilePrefix={data.phonePrefix}
                          mobile={data.phone}
                        />
                      : '-'
                    }
                  </ContentPlaceholder>
                </Grid.Column>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(Overview.mapStateToProps)(Overview));



// WEBPACK FOOTER //
// ./src/containers/Project/Overview.jsx